import * as firebase from "firebase/app";
import "firebase/auth";
import {getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged} from "firebase/auth";
import {
    setDoc,
    getFirestore,
    collection,
    where,
    query,
    limit,
    getDocs,
    updateDoc,
    doc
} from "firebase/firestore";
import {User} from "./types";

const firebaseConfig = {
    apiKey: "AIzaSyA1bStJNvfbKWzXoMeT22VV9ohgen0CTfc",
    authDomain: "selfpause-10e5a.firebaseapp.com",
    databaseURL: "https://selfpause-10e5a.firebaseio.com",
    projectId: "selfpause-10e5a",
    storageBucket: "selfpause-10e5a.appspot.com",
    messagingSenderId: "1044371968440",
    appId: "1:1044371968440:web:5d372d9ae03978d32abf4d",
    measurementId: "G-6TV4FPS7L9"
};

let app;
app = firebase.initializeApp(firebaseConfig);
export {app}

export const initApp = () => {
    if (!app) {
        app = firebase.initializeApp(firebaseConfig);
        return app
    } else return app
}

const db = getFirestore(app)
export const auth = getAuth(app)

export const signInWithGoogle = (): Promise<any> => {
    const provider = new GoogleAuthProvider();
    return signInWithPopup(auth, provider);
}

export const logout = async (): Promise<void> => {
    await signOut(auth);
};

type SetOnAuthStateChangeParams = {
    onStateChange: (user) => void;
    onError: (error) => void;
    onCompletion: () => void;
}
export const setOnAuthStateChange = ({onStateChange, onError, onCompletion}: SetOnAuthStateChangeParams): void => {
    onAuthStateChanged(auth, onStateChange, onError, onCompletion)
}

export const createUser = async (userDetails: User): Promise<void> => {
    const newUserRef = await doc(collection(db, 'users'))
    const newUserData = {...userDetails, id: newUserRef.id}
    return await setDoc(newUserRef, newUserData)
}

type UpdateUserParams = {
    email: string;
    instagramHandle?: string;
    pinCode: string;
}

type UpdateUserReturnType = Promise<{ status: "success" | "error", message: string }>

export const updateUser = async ({email, instagramHandle, pinCode}: UpdateUserParams, codes): UpdateUserReturnType => {
    let date = new Date(),
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate(),
        oneYearFromNow = new Date(year + 1, month, day),
        twoMonthsFromNow = new Date(year, month + 1, day);
    const dataToUpdate: any = {
        giftedTrial: {
            endDate: instagramHandle ? oneYearFromNow : twoMonthsFromNow
        },
        premium: true,
        receipt: ""
    }
    instagramHandle ? dataToUpdate.influencer = [{
        platform: "instagram",
        account: instagramHandle
    }] : ''
    try {
        if (instagramHandle && codes.value.trim().toUpperCase() !== pinCode.trim().toUpperCase()) throw new Error("The pin code you have entered is incorrect or expired.")
        if (!instagramHandle && codes.promoCode.trim().toUpperCase() !== pinCode.trim().toUpperCase()) throw new Error("The pin code you have entered is incorrect or expired.")
        const usersRef = await collection(db, "users")
        const q = await query(usersRef, where("email", "==", email.toLowerCase()), limit(1))
        const docs = await getDocs(q)
        if (docs.docs.length === 0) throw new Error("It doesn't appear we have an account with that email. Please check the spelling of the email you submitted and try again.")
        else if (docs.docs.length > 1) throw new Error("It looks like we are having an issue with your email. I've logged the issue and we will get back to ASAP.")
        else if (docs.docs.length === 1) {
            for (const user of docs.docs) {
                const {uid} = user.data()
                const docRef = await doc(usersRef, uid)
                await updateDoc(docRef, dataToUpdate)
            }
        }
        return {status: 'success', message: "Success! We found your account!"}
    } catch (e) {
        return {status: "error", message: String(e)}
    }
}